import { listDepartments } from "@/grid/config/registry";
import { cn } from "@/lib/cn";
import { Link, useLocation } from "react-router-dom";

interface DepartmentTargetsNavProps {
  className?: string;
}

export function DepartmentTargetsNav({ className }: DepartmentTargetsNavProps) {
  const location = useLocation();
  const departments = listDepartments();

  return (
    <nav className={cn("space-y-1", className)} aria-label="Departments">
      {departments.map((department, index) => {
        const href = `/targets/${department.id}`;
        const active = location.pathname === href;
        return (
          <Link
            key={department.id}
            to={href}
            className={cn(
              "flex w-full items-center gap-3 rounded-xl px-3 py-2.5 text-left text-sm transition-colors",
              active
                ? "bg-white font-medium text-[var(--color-text)] shadow-sm ring-1 ring-[var(--color-border)]"
                : "text-[var(--color-text-muted)] hover:bg-white/70 hover:text-[var(--color-text)]",
            )}
          >
            <span className="w-5 text-xs tabular-nums opacity-50">
              {String(index + 1).padStart(2, "0")}
            </span>
            <span>{department.name}</span>
          </Link>
        );
      })}
    </nav>
  );
}
